import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { withClientOnly } from '../client-only';
import { useMarketplaceApplyCouponCode } from '../../graphql';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CouponCodeDetector = () => {
  const router = useRouter();
  const marketplaceApplyCouponCode = useMarketplaceApplyCouponCode();
  const path = router.asPath;
  const pathHashIndex = path.indexOf('#');
  const pathWithoutHash = pathHashIndex === -1 ? path : path.slice(0, pathHashIndex);
  const pathHash = pathHashIndex === -1 ? '' : path.slice(pathHashIndex);
  const couponCode = extractCouponCodeFromHash(pathHash);
  useEffect(() => {
    if (couponCode) {
      marketplaceApplyCouponCode(couponCode, () => {
        router.replace(pathWithoutHash, undefined, {
          shallow: true,
          scroll: false
        });
      });
    }
  }, [couponCode, marketplaceApplyCouponCode, router, pathWithoutHash]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export function extractCouponCodeFromHash(hash) {
  const couponHashPrefix = '#coupon:';
  if (hash.startsWith(couponHashPrefix)) {
    const coupon = hash.slice(couponHashPrefix.length);
    if (coupon) {
      return coupon;
    }
  }
  return undefined;
}
export default withClientOnly(CouponCodeDetector);